import { Goal, ID } from '@griply/types';

// Undefined = renders as a root because an active filter dropped every ancestor.
export const getNearestPresentParentId = (
  goal: Goal,
  isPresent: (id: ID) => boolean,
): ID | undefined => [...(goal.parentIds ?? [])].reverse().find(isPresent);
